const data = {
  body: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.66669 4H13.3334M2.66669 8H13.3334M5.50001 12H10.1667" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  width: 16,
  height: 16
}
export default data
